import { render } from "./Collapsible.vue?vue&type=template&id=38ddc8c6&scoped=true&ts=true"
import script from "./Collapsible.vue?vue&type=script&lang=ts"
export * from "./Collapsible.vue?vue&type=script&lang=ts"

import "./Collapsible.vue?vue&type=style&index=0&id=38ddc8c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ddc8c6"]])

export default __exports__